export default {
  LIST_FETCHED: 'GIVEAWAY_NUMBERS_FETCHED',
  LIST_LOAD: 'GIVEAWAY_NUMBERS_LOAD',
  ITEM_DETAIL: 'GIVEAWAY_NUMBERS_DETAIL',
  BUTTON_LOAD: 'GIVEAWAY_NUMBERS_BUTTON_LOAD',
  WINNER_FETCHED: 'GIVEAWAY_WINNERS_FETCHED',
};
